import { connect } from 'react-redux'

import {
  setOfferFormImportValueRoutine,
  setOfferFormGeneralValueRoutine,
  setOfferFormExportValueRoutine,
  setOfferFormPostImportValueRoutine,
  setOfferFormFreeCarriersValueRoutine,
  createExportOfferRoutine,
  createImportOfferRoutine,
  createGeneralOfferRoutine,
  createFreeCarriersOfferRoutine,
  createPostImportOfferRoutine,
  clearImportOfferFormRoutine,
  clearGeneralOfferFormRoutine,
  clearExportOfferFormRoutine,
  clearPostImportOfferFormRoutine,
  clearFreeCarriersOfferFormRoutine,
  getExportMyCompanyLastOffersRoutine,
  getImportMyCompanyLastOffersRoutine,
  getGeneralMyCompanyLastOffersRoutine,
  getFreeCarriersMyCompanyLastOffersRoutine,
  getPostImportMyCompanyLastOffersRoutine,
  getExportOfferTemplatesRoutine,
  getImportOfferTemplatesRoutine,
  getGeneralOfferTemplatesRoutine,
  getFreeCarriersOfferTemplatesRoutine,
  getPostImportOfferTemplatesRoutine,
  fillFormUsingTemplateExportRoutine,
  fillFormUsingTemplateImportRoutine,
  fillFormUsingTemplateGeneralRoutine,
  fillFormUsingTemplateFreeCarriersRoutine,
  fillFormUsingTemplatePostImportRoutine,
  removeTemplateExportRoutine,
  removeTemplateImportRoutine,
  removeTemplateGeneralRoutine,
  removeTemplateFreeCarriersRoutine,
  removeTemplatePostImportRoutine,
  createBulkExportOffersRoutine,
  createBulkImportOffersRoutine,
  createBulkGeneralOffersRoutine,
  createBulkFreeCarriersOffersRoutine,
  createBulkPostImportOffersRoutine,
  createAndDuplicateExportOfferRoutine,
  createAndDuplicateImportOfferRoutine,
  createAndDuplicateGeneralOfferRoutine,
  createAndDuplicateFreeCarriersOfferRoutine,
  createAndDuplicatePostImportOfferRoutine,
  createAndStartNewExportOfferRoutine,
  createAndStartNewImportOfferRoutine,
  createAndStartNewGeneralOfferRoutine,
  createAndStartNewFreeCarriersOfferRoutine,
  createAndStartNewPostImportOfferRoutine,
  createContractOfferRoutine,
  setOfferFormContractValueRoutine,
  clearContractOfferRoutine
} from './actions'

import {
  selectOfferFormImportData,
  selectOfferFormGeneralData,
  selectOfferFormExportData,
  selectOfferFormPostImportData,
  selectOfferFormFreeCarriersData,
  selectMyCompanyExportLastOffers,
  selectMyCompanyImportLastOffers,
  selectMyCompanyGeneralLastOffers,
  selectMyCompanyFreeCarriersLastOffers,
  selectMyCompanyPostImportLastOffers,
  selectOfferTemplatesExport,
  selectOfferTemplatesImport,
  selectOfferTemplatesGeneral,
  selectOfferTemplatesFreeCarriers,
  selectOfferTemplatesPostImport,
  selectOfferFormContractData
} from './selectors'

const mapStateToProps = state => ({
  offerFormImport: selectOfferFormImportData(state),
  offerFormGeneral: selectOfferFormGeneralData(state),
  offerFormExport: selectOfferFormExportData(state),
  offerFormPostImport: selectOfferFormPostImportData(state),
  offerFormFreeCarriers: selectOfferFormFreeCarriersData(state),
  offerFormContracts: selectOfferFormContractData(state),

  lastOffersExport: selectMyCompanyExportLastOffers(state),
  lastOffersImport: selectMyCompanyImportLastOffers(state),
  lastOffersGeneral: selectMyCompanyGeneralLastOffers(state),
  lastOffersFreeCarriers: selectMyCompanyFreeCarriersLastOffers(state),
  lastOffersPostImport: selectMyCompanyPostImportLastOffers(state),

  offerTemplatesExport: selectOfferTemplatesExport(state),
  offerTemplatesImport: selectOfferTemplatesImport(state),
  offerTemplatesGeneral: selectOfferTemplatesGeneral(state),
  offerTemplatesFreeCarriers: selectOfferTemplatesFreeCarriers(state),
  offerTemplatesPostImport: selectOfferTemplatesPostImport(state)
})

const mapDispatchToProps = dispatch => ({
  setOfferFormImportValue: (name, value) =>
    dispatch(setOfferFormImportValueRoutine({ name, value })),
  setOfferFormGeneralValue: (name, value) =>
    dispatch(setOfferFormGeneralValueRoutine({ name, value })),
  setOfferFormExportValue: (name, value) =>
    dispatch(setOfferFormExportValueRoutine({ name, value })),
  setOfferFormPostImportValue: (name, value) =>
    dispatch(setOfferFormPostImportValueRoutine({ name, value })),
  setOfferFormFreeCarriersValue: (name, value) =>
    dispatch(setOfferFormFreeCarriersValueRoutine({ name, value })),
  setOfferFormContractValue: (name, value) =>
    dispatch(setOfferFormContractValueRoutine({ name, value })),

  createExportOffer: () => dispatch(createExportOfferRoutine()),
  createImportOffer: () => dispatch(createImportOfferRoutine()),
  createGeneralOffer: () => dispatch(createGeneralOfferRoutine()),
  createFreeCarriersOffer: () => dispatch(createFreeCarriersOfferRoutine()),
  createPostImportOffer: () => dispatch(createPostImportOfferRoutine()),
  createContractOffer: () => dispatch(createContractOfferRoutine()),

  createBulkExportOffers: number =>
    dispatch(createBulkExportOffersRoutine({ number })),
  createBulkImportOffers: number =>
    dispatch(createBulkImportOffersRoutine({ number })),
  createBulkGeneralOffers: number =>
    dispatch(createBulkGeneralOffersRoutine({ number })),
  createBulkFreeCarriersOffers: number =>
    dispatch(createBulkFreeCarriersOffersRoutine({ number })),
  createBulkPostImportOffers: number =>
    dispatch(createBulkPostImportOffersRoutine({ number })),

  createAndDuplicateExportOffer: () =>
    dispatch(createAndDuplicateExportOfferRoutine()),
  createAndDuplicateImportOffer: () =>
    dispatch(createAndDuplicateImportOfferRoutine()),
  createAndDuplicateGeneralOffer: () =>
    dispatch(createAndDuplicateGeneralOfferRoutine()),
  createAndDuplicateFreeCarriersOffer: () =>
    dispatch(createAndDuplicateFreeCarriersOfferRoutine()),
  createAndDuplicatePostImportOffer: () =>
    dispatch(createAndDuplicatePostImportOfferRoutine()),

  createAndStartNewExportOffer: () =>
    dispatch(createAndStartNewExportOfferRoutine()),
  createAndStartNewImportOffer: () =>
    dispatch(createAndStartNewImportOfferRoutine()),
  createAndStartNewGeneralOffer: () =>
    dispatch(createAndStartNewGeneralOfferRoutine()),
  createAndStartNewFreeCarriersOffer: () =>
    dispatch(createAndStartNewFreeCarriersOfferRoutine()),
  createAndStartNewPostImportOffer: () =>
    dispatch(createAndStartNewPostImportOfferRoutine()),

  clearImportOfferForm: () => dispatch(clearImportOfferFormRoutine()),
  clearGeneralOfferForm: () => dispatch(clearGeneralOfferFormRoutine()),
  clearExportOfferForm: () => dispatch(clearExportOfferFormRoutine()),
  clearPostImportOfferForm: () => dispatch(clearPostImportOfferFormRoutine()),
  clearFreeCarriersOfferForm: () =>
    dispatch(clearFreeCarriersOfferFormRoutine()),
  clearContractOffer: () => dispatch(clearContractOfferRoutine()),

  getExportMyCompanyLastOffers: () =>
    dispatch(getExportMyCompanyLastOffersRoutine()),
  getImportMyCompanyLastOffers: () =>
    dispatch(getImportMyCompanyLastOffersRoutine()),
  getGeneralMyCompanyLastOffers: () =>
    dispatch(getGeneralMyCompanyLastOffersRoutine()),
  getFreeCarriersMyCompanyLastOffers: () =>
    dispatch(getFreeCarriersMyCompanyLastOffersRoutine()),
  getPostImportMyCompanyLastOffers: () =>
    dispatch(getPostImportMyCompanyLastOffersRoutine()),

  getExportOfferTemplates: () => dispatch(getExportOfferTemplatesRoutine()),
  getImportOfferTemplates: () => dispatch(getImportOfferTemplatesRoutine()),
  getGeneralOfferTemplates: () => dispatch(getGeneralOfferTemplatesRoutine()),
  getFreeCarriersOfferTemplates: () =>
    dispatch(getFreeCarriersOfferTemplatesRoutine()),
  getPostImportOfferTemplates: () =>
    dispatch(getPostImportOfferTemplatesRoutine()),

  fillFormUsingTemplateExport: template =>
    dispatch(fillFormUsingTemplateExportRoutine({ template })),
  fillFormUsingTemplateImport: template =>
    dispatch(fillFormUsingTemplateImportRoutine({ template })),
  fillFormUsingTemplateGeneral: template =>
    dispatch(fillFormUsingTemplateGeneralRoutine({ template })),
  fillFormUsingTemplateFreeCarriers: template =>
    dispatch(fillFormUsingTemplateFreeCarriersRoutine({ template })),
  fillFormUsingTemplatePostImport: template =>
    dispatch(fillFormUsingTemplatePostImportRoutine({ template })),

  removeTemplateExport: id => dispatch(removeTemplateExportRoutine({ id })),
  removeTemplateImport: id => dispatch(removeTemplateImportRoutine({ id })),
  removeTemplateGeneral: id => dispatch(removeTemplateGeneralRoutine({ id })),
  removeTemplateFreeCarriers: id =>
    dispatch(removeTemplateFreeCarriersRoutine({ id })),
  removeTemplatePostImport: id =>
    dispatch(removeTemplatePostImportRoutine({ id }))
})

export default connect(mapStateToProps, mapDispatchToProps)
